module.exports = __webpack_public_path__ + "img/ico_star.37857ad3.svg";